import { render, staticRenderFns } from "./AscentStatusIconInput.vue?vue&type=template&id=5dea31d2"
import script from "./AscentStatusIconInput.vue?vue&type=script&lang=js"
export * from "./AscentStatusIconInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports